import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import { trackEvent } from "utils/tracking";

export default function DefaultActivityCard() {
  const navigate = useNavigate();
  const goToBrandsPage = () => {
    navigate(`/${routes.brands}`);
    trackEvent("Send Emails Action Item Button Clicked");
  };

  return (
    <Card elevation={2} sx={{ backgroundColor: "#E9F1EA" }}>
      <CardActionArea onClick={goToBrandsPage}>
        <CardContent>
          <Typography gutterBottom variant="h6" component="div">
            Send more outreach
          </Typography>
          <Typography color="textSecondary" paragraph>
            Pitching is a numbers game. Send more emails and you will likely
            land more brand deals.
          </Typography>
          <Button
            component="div"
            size="small"
            color="primary"
            variant="contained"
            sx={{ textTransform: "none" }}
            disableElevation
          >
            Send Emails
            <Box
              sx={{ ml: 1 }}
              component="i"
              className="fa-solid fa-paper-plane"
            />
          </Button>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
